// Government event kinds — color-coded by urgency/type
export const GOV_EVENT_KINDS: Record<string, { color: string; icon: string; label: string }> = {
  response_deadline:        { color: '#DC2626', icon: '🚨', label: 'Response Due' },
  sources_sought_deadline:  { color: '#8B5CF6', icon: '🎯', label: 'Sources Sought Due' },
  qa_cutoff:                { color: '#F97316', icon: '❓', label: 'Q&A Cutoff' },
  site_visit:               { color: '#3B82F6', icon: '📍', label: 'Site Visit' },
  amendment_check:          { color: '#EAB308', icon: '📝', label: 'Amendment Check' },
  internal_review:          { color: '#0EA5E9', icon: '🔍', label: 'Internal Review' },
  draft_deadline:           { color: '#F59E0B', icon: '✍️', label: 'Draft Due' },
  cost_review:              { color: '#10B981', icon: '💰', label: 'Cost Review' },
  team_meeting:             { color: '#6366F1', icon: '👥', label: 'Team Meeting' },
  bond_deadline:            { color: '#EF4444', icon: '🔒', label: 'Bond Deadline' },
  award_expected:           { color: '#84CC16', icon: '📅', label: 'Award Expected' },
  follow_up:                { color: '#F97316', icon: '📞', label: 'POC Follow-Up' },
  award:                    { color: '#EAB308', icon: '🏆', label: 'Award' },
  // Construction milestones
  ntp:                      { color: '#3B82F6', icon: '📢', label: 'NTP' },
  pop_start:                { color: '#10B981', icon: '🚀', label: 'PoP Start' },
  pop_end:                  { color: '#EF4444', icon: '🏁', label: 'PoP End' },
  substantial_completion:   { color: '#22C55E', icon: '✅', label: 'Substantial Completion' },
  final_acceptance:         { color: '#EAB308', icon: '🎉', label: 'Final Acceptance' },
  other:                    { color: '#64748B', icon: '📅', label: 'Gov Event' },
};
